import type { Admin } from './';

export default ({ admin }: Admin.State) => ({
  /**
   * Get reimbursement
   */
  getReimbursements: () => {
    return admin
      .filter((message) => !message.claimed)
      .reduce(
        (sum, item) => {
          sum.coins += item.coins;
          sum.gems += item.freeGems;

          return sum;
        },
        { coins: 0, gems: 0 },
      );
  },

  /**
   * Check if there is not calmed reward
   */
  hasReimbursements: () => {
    return admin.some((message) => !message.claimed);
  },
});
